import PropTypes from 'prop-types'
import React from 'react'
import content from 'pp-react-l10n'
import $ from 'jquery'
import Overpanel from 'react-components/overpanel'
import { isIframe } from 'iframe-support'

const loginRedirectPath = '/signin' // A full page load

let i18n = content('widgets/confirmSession')

class SessionTimer extends React.Component {
  static propTypes = {
    confirmTime: PropTypes.number,
    expireTime: PropTypes.number,
    extendURL: PropTypes.string,
    onConfirmOpen: PropTypes.func,
    isGuest: PropTypes.bool,
    env: PropTypes.string,
  }

  static defaultProps = {
    onConfirmOpen: () => {},
    confirmTime: 14 * 60 * 1000, // 14 minutes
    expireTime: 15 * 60 * 1000, // 15 minutes
    extendURL: '/myaccount/extendSession',
  }

  state = {
    isOpen: false,
  }

  componentDidMount() {
    if (this.props.env !== 'pools') {
      this.startTimers()
    }
  }

  componentWillUnmount() {
    this.clearTimers()
  }

  open = () => {
    this.setState({ isOpen: true })
    this.props.onConfirmOpen()
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  onSessionExtended = () => {
    this.close()
    this.clearTimers()
    this.startTimers()
  }

  clearTimers = () => {
    clearTimeout(this.confirmationTimer)
    clearTimeout(this.expirationTimer)
  }

  startTimers = () => {
    // Add 14 minute timer to allow the user to rescue the session before it expires
    this.confirmationTimer = setTimeout(() => {
      this.open()
    }, this.props.confirmTime)

    // Add 15 minute timer to redirect user to login screen,
    // so that sensitive information is no longer viewable in the source
    this.expirationTimer = setTimeout(() => {
      if (isIframe()) {
        window.top.location.href = loginRedirectPath
      }
      window.location = loginRedirectPath
    }, this.props.expireTime)
  }

  extendSession = () => {
    $.ajax({
      type: 'POST',
      url: this.props.extendURL,
      success: () => this.onSessionExtended(),
      dataType: 'json',
    })
  }

  render() {
    let bodyKey = this.props.isGuest
      ? 'confirmSession.guestConfirmBody'
      : 'confirmSession.confirmBody'
    let buttonKey = this.props.isGuest
      ? 'confirmSession.guestConfirmContinue'
      : 'confirmSession.confirmContinue'

    return (
      <Overpanel
        show={this.state.isOpen}
        preset="FULL"
        handleClose={this.close}
        a11yTitle={i18n('confirmSession.confirmHeader')}
        zIndex={1051}
      >
        <div>
          <div className="fullScreenDialog">
            <span
              className="icon icon-large icon-attention-large"
              aria-hidden="true"
            />
            <h2 className="x-large">{i18n('confirmSession.confirmHeader')}</h2>
          </div>
          <div className="fullScreenDialog">
            <p className="fullBodyText">{i18n(bodyKey)}</p>
            <p>
              <button
                onClick={this.extendSession}
                className="btn extendSession"
              >
                {i18n(buttonKey)}
              </button>
            </p>
          </div>
        </div>
      </Overpanel>
    )
  }
}

export default SessionTimer
